module.exports = __webpack_public_path__ + "static/media/co.a22d500f.svg";